<template>
  <Modal
    v-model="showModal"
    title="Payment Method"
    footer-hide>
    <div class="payment-method-form">
      <!-- <div class="padding-b-20">
        <RadioGroup v-model="formData.payment_type">
          <Radio label="creditcard" style="margin-right:50px">Credit card</Radio>
          <Radio label="wiretransfer" disabled>Wire transfer</Radio>
        </RadioGroup>
      </div> -->

      <CreditCardForm ref="CreditCardForm" v-if="formData.payment_type == 'creditcard'" v-model="formData" @success="handleSuccess"/>
      <WireTransferForm ref="WireTransferForm" v-if="formData.payment_type == 'wiretransfer'" v-model="formData" @success="handleSuccess"/>

      <div class="text-right">
        <Button class="k-btn-1" @click="handlePayment" size="large" :loading="isLoading">Save</Button>
      </div>
    </div>
  </Modal>
</template>

<script>

import { addPaymentMethod } from '@/services/payments'
import CreditCardForm from './CreditCardForm'
import WireTransferForm from './WireTransferForm'

export default {
  components: {
    CreditCardForm,
    WireTransferForm
  },

  data () {
    return {
      showModal: false,
      isLoading: false,
      formData: {
        rfp: null,
        account_name: null,
        bank_name: null,
        account_number: null,
        payment_type: 'creditcard',
        card_number: null,
        expiry_date: null,
        cvc: null,
        remember_card: true,
        amount: 100
      },
      isSuccess: true
    }
  },

  methods: {
    openModal () {
      this.formData = {
        rfp: null,
        account_name: null,
        bank_name: null,
        account_number: null,
        payment_type: 'creditcard',
        card_number: null,
        expiry_date: null,
        cvc: null,
        remember_card: true,
        amount: 100
      }
      this.showModal = true
    },

    handlePayment () {
      this.isSuccess = true
      if (this.formData.payment_type === 'creditcard') {
        this.$refs.CreditCardForm.handleSubmit()
      }
      if (this.formData.payment_type === 'wiretransfer') {
        this.$refs.WireTransferForm.handleSubmit()
      }

      if (this.isSuccess) {
        this.isLoading = true
        const data = JSON.parse(JSON.stringify(this.formData))
        if (data.card_number) data.card_number = Number(data.card_number.split(' ').join(''))
        if (data.account_number) data.account_number = Number(data.account_number.split(' ').join(''))
        addPaymentMethod(data).then(res => {
          this.isLoading = false
          this.showModal = false
          this.$emit('reload')
        }).catch(err => {
          console.log('Failed to add new payment method: ', err)
          this.$Message.error({
            background: true,
            duration: 5,
            content: err.response.data.message
          })
          this.isLoading = false
        })
      }
    },

    handleGoBack () {
      this.$router.go(-1)
    },

    handleSuccess (isSuccess) {
      if (!isSuccess) this.isSuccess = isSuccess
    }
  }
}
</script>
